import { createUserManager } from 'redux-oidc'
import { constants } from 'consts'

const { authentication: auth } = constants
const config = {
  authority: auth.AUTHORITY_URI,
  client_id: auth.CLIENT_ID,
  redirect_uri: auth.REDIRECT_URI,
  silent_redirect_uri: auth.SILENT_REDIRECT_URI,
  response_type: 'id_token token',
  client_secret: auth.CLIENT_SECRET,
  scope: 'openid offline_access winelist_admin_api profile',
  post_logout_redirect_uri: auth.POST_LOGOUT_REDIRECT_URI,
  automaticSilentRenew: true,
  silentRequestTimeout: 60000,
  filterProtocolClaims: true,
  loadUserInfo: true
}

const userManager = createUserManager(config)

export {
  userManager
}
